export default [
  {
    name: 'goodHome',//湖北省高校成人学士学位外语考试联盟
    path: '/goodHome',
    meta: {
      title: '湖北省高校成人学士学位外语考试联盟',
      showTab: false,
      goHome: true,
    },
    component: () => import("@/pages/FBHOME/goodHome.vue"),
  },
]